import Orientation from './Orientation';
function App() { return <Orientation />; }
export default App;